<template>
    <div class="response-modal-wrapper" v-if="isResetPassModalOpen" @click="closeResetPassModal">
        <div data-aos="fade-left" class="response-modal" @click.stop>
            <div class="response-header">
                <div class="response-title">
                    <p>Passwort zurücksetzen</p>
                </div>

                <div @click="closeResetPassModal" class="response-close-btn pointer">
                    <img alt="icon" src="../assets/icons/modal_close_icon.svg"/>
                </div>
            </div>

            <div class="response-info"> 
                <p>Geben Sie Ihre E-Mail ein, um Ihr neues Passwort zu erhalten</p>
            </div>

            <div class="form-el">
                <input type="email" class="form-input" v-model="email" :class="{ 'form-input-err': v$.email.$errors.length > 0 }" >
            </div>
            <div v-for="error in v$.email.$errors" :key="error.$uid"> 
                <p class="err-msg">{{error.$message}}</p>
            </div>
            <div class="form-footer">
                <div class="footer-btn next-btn ml-a" @click="sendReset"> 
                    <p v-if="!isSending">Einreichen</p>
                    <span v-else  class="loader"></span>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import {
    modalsComputed,
    modalsMethods
} from "../store/helpers";
import Swal from 'sweetalert2';
import axios from "axios";
import useValidate from '@vuelidate/core'
import {
    required, 
    email, 
    helpers
} from "@vuelidate/validators";
export default {
    computed: { 
        ...modalsComputed,
    },
    methods: {
        ...modalsMethods,

        closeResetPassModal() {
            this.toggleResetPassModal(false);  
            this.setEmailToResetVal(null); 
        },

        async sendReset() {
            this.isSending = true;
            this.v$.email.$touch();
            if (this.v$.email.$invalid) {
                Swal.fire("Validierungsfehler..", '', "warning").then(() => {
                    this.isSending = false;
                }); 
            }else{ 
                await axios.post(`api/v1/portal/forgot-password`, {email:this.email})
                .then(()=>{
                    let timerInterval;
                    Swal.fire({
                        title: "Erfolgreich gesendet, bitte überprüfen Sie Ihre E-Mail!",
                        timer: 1500,
                        timerProgressBar: true,
                        icon: "success",
                        showConfirmButton: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                            timerInterval = setInterval(() => {
                                Swal.getContent().querySelector("b").textContent =
                                    Swal.getTimerLeft();
                                }, 100);
                            },
                            onClose: () => {
                                clearInterval(timerInterval);
                            },
                    }).then(() => {
                        this.v$.$reset();
                        this.email = '';
                        this.isSending = false;  
                        this.closeResetPassModal(); 
                    }); 
                })
                .catch(error => {
                    const errorMessage = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : "Ein unerwarteter Fehler ist aufgetreten.";

                    Swal.fire("Da ist etwas schiefgelaufen.", errorMessage, "warning").then(() => {
                        this.v$.$reset();
                        this.email = '';
                        this.isSending = false;  
                        this.closeResetPassModal(); 
                    });
                }) 
            }
        }, 
    },
    data() {
        return {
            v$: useValidate(),
            isSending: false,
            email: '',
        };
    },
    validations() {
        return {
            email: {
                required:helpers.withMessage('Ist erforderlich', required), 
                email: helpers.withMessage('Der Wert ist keine gültige E-Mail-Adresse', email),
            }, 
        }
    },
};
</script>

<style scoped>
.loader {
    width: 30px !important;
    height: 30px !important;
    border: 4px solid white !important;
    border-bottom-color: transparent !important;
}
</style>
